var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field" }, [
    _c("label", { staticClass: "label", attrs: { for: _vm.id } }, [
      _vm._v("\n    Teléfono\n  ")
    ]),
    _c(
      "div",
      { staticClass: "control has-icons-left", class: _vm.controlClass },
      [
        _c("input", {
          ref: "phoneNumber",
          staticClass: "input",
          attrs: {
            id: _vm.id,
            name: _vm.name,
            maxlength: "16",
            placeholder: _vm.placeholder,
            pattern: _vm.phonePattern,
            disabled: _vm.disabled,
            required: _vm.required,
            readonly: _vm.readonly
          },
          domProps: { value: _vm.value },
          on: { input: _vm.onInput, change: _vm.onChange }
        }),
        _c("b-icon", {
          staticClass: "is-small is-left is-unselectable",
          attrs: { icon: "phone" }
        }),
        _vm.isValid && _vm.validIcon
          ? _c("b-icon", {
              staticClass: "is-small is-right is-unselectable has-text-success",
              attrs: { icon: "done" }
            })
          : _vm._e(),
        _c("p", { staticClass: "help is-danger" }, [
          _vm._v(
            "\n      El valor proporcionado no es un teléfono válido\n    "
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }